import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useVerificationUpgrade } from "../../Invoices/components/VerificationUpgrade/VerificationUpgrade";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { OverlaySpinner } from "../../components/OverlaySpinner";
import { PaymentsSetup } from "../../modules/PaymentsSetup";
import { WSQueries } from "../../query/WSQuery";
import { QUERY_BOOKKEEPING_BANKING_ACCOUNT } from "../../query/bookkeeping/keys";
import { useBankingAccount } from "../../query/bookkeeping/queries";
import { useWSMutation } from "../../query/helpers";
import { useUserId } from "../../query/hooks/helpers";
import {
  usePaymentsStatusQuery,
  usePayoutSettings
} from "../../query/payments/queries";
import { QUERY_USERS_ACTIVITIES } from "../../query/users/keys";
import { useActivities } from "../../query/users/queries";
import { usersService } from "../../services/users";
import { WalletDashboard } from "./WalletDashboard";
import { WalletPreview } from "./WalletPreview";
import { WalletSetupDistribution } from "./WalletSetupDistribution";

export const WalletIndex: React.FC = () => {
  const userId = useUserId();
  const qActivity = useActivities(userId);
  const qBankingAccount = useBankingAccount();
  const qPaymentsStatus = usePaymentsStatusQuery();
  const history = useHistory();
  const {
    requestVerification,
    requestVerificationMeta,
    isBankingRequested
  } = useVerificationUpgrade();

  const [finishPaymnetsOnboarding] = useWSMutation(
    async () => {
      if (!isBankingRequested) {
        await requestVerification({
          banking: true
        });
      }
      await usersService.activity.update(userId, {
        flows: {
          walletSetup: {
            totalSteps: 2,
            currentStep: 1,
            version: 2,
            complete: false
          }
        }
      });

      history.push("/member/wallet/set-up/distribution");
    },
    {
      dependencies: [QUERY_USERS_ACTIVITIES, QUERY_BOOKKEEPING_BANKING_ACCOUNT]
    }
  );

  if (!qBankingAccount.isFetched) {
    return <BrowserPageTitle title="Wallet" />;
  }

  return (
    <>
      <BrowserPageTitle title="Wallet" />
      {requestVerificationMeta.isLoading && <OverlaySpinner zIndex={1000} />}
      <WSQueries queries={{ qActivity, qPaymentsStatus }}>
        {({ qActivity, qPaymentsStatus }) => {
          return (
            <Switch>
              <Route
                path="/member/wallet/set-up/preview"
                exact
                component={WalletPreview}
              />
              <Route
                path="/member/wallet/set-up/distribution"
                exact
                component={WalletSetupDistribution}
              />

              <Route
                path="/member/wallet/set-up/payments"
                render={() => (
                  <PaymentsSetup
                    basePath="/member/wallet/set-up/payments"
                    onBack={() => {
                      history.push("/member/wallet/set-up/preview");
                    }}
                    onFinish={finishPaymnetsOnboarding}
                  />
                )}
              />

              {!qActivity.data.flows.walletSetup?.complete &&
              qPaymentsStatus.data?.verifications.banking !==
                VerificationStatus.Verified ? (
                <Redirect from="*" to="/member/wallet/set-up/preview" />
              ) : null}

              <Route
                path="/member/wallet/dashboard"
                component={WalletDashboard}
              />

              <Redirect from="*" to="/member/wallet/dashboard" />
            </Switch>
          );
        }}
      </WSQueries>
    </>
  );
};
